import React, { useContext } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { LayoutContext } from "App/common/hoc/Layout";
import { SPopupContext } from "App/common/hoc/SlidingPopup";
import Loader from "App/common/ui/Loader";
import { decodeHandler, formatBytes, isDecodable, sortArray } from "utils";
import { initiateStopRestore } from "store/actions";

function RestoreDetailedProgress(props) {
  const { lState, lMethods } = useContext(LayoutContext);
  const { sPopupMethods } = useContext(SPopupContext);
  const progress =
    props.clients[lState.slidingPopup.params.clientUUID].restoreStatus;
  const detailedProgress = progress;
  const machineStatus =
    props.clients[lState.slidingPopup.params.clientUUID].machineStatus;
  const status =
    props.enums.RestoreStatus.props[
      props.clients[lState.slidingPopup.params.clientUUID].restoreStatus.status
    ].key;

  if (
    progress.completed ||
    progress.failed ||
    status === "CANCELLED" ||
    status === "PAUSED" ||
    machineStatus === "offline"
  ) {
    const timer = setTimeout(() => {
      lMethods.closeSlidingPopup();
      clearTimeout(timer);
    }, 1000);
  }

  return (
    <React.Fragment>
      {detailedProgress ? (
        <div className="slider_content_backup">
          <div className="slider_summary">
            <div className="slider_content_body">
              <div className="view_list_logs_wrap__body">
                <div className="vll_item_heading">
                  <h3>View progress of the restore</h3>
                </div>
                {detailedProgress?.files?.length > 0 ? (
                  <div className="vll_item vll_progress">
                    <div className="vll_item__content">
                      <div className="vll_item_restore_progress">
                        {detailedProgress.files.map((file, index) => (
                          <div
                            className={
                              "vll_item__content__subitem vll_subitem_" + index
                            }
                          >
                            <div className="vll_item__content__subitem_icon">
                              {" "}
                            </div>
                            <div className="vll_item__content__subitem_info">
                              <div className="drive_loader_info">
                                <div className="dl__name">
                                  {isDecodable(
                                    file.path,
                                    "BackupRestore progress -"
                                  )
                                    ? decodeHandler(file.path)
                                    : file.path}
                                </div>
                                <div className="dl__loader">
                                  {" "}
                                  {file.progress}%{" "}
                                </div>
                              </div>
                              <div className="subitem_info__storage">
                                <div
                                  className="subitem_info__storage__line"
                                  style={{ width: `${file.progress}%` }}
                                ></div>
                              </div>
                              <div className="pc_storage_data">
                                <p>
                                  file size: {formatBytes(file.bytesWritten)}/
                                  {formatBytes(file.size)}
                                </p>
                              </div>
                            </div>
                            {file.progress == 100 ? (
                              <div class="vll_item__content__subitem_status vll_done">
                                {" "}
                              </div>
                            ) : (
                              <div className="vll_item__content__subitem_status vll_inprogress">
                                In-Progress
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ) : (
                  <Loader />
                )}
              </div>
            </div>
            <div className="slider_content_footer">
              <div className="slider_summary_btns">
                <div className="slider_summary_btns__inner">
                  <div className="backup_image_btns just_flex">
                    <div
                      className={[
                        "slider_btn slider_btn_delete",
                        (progress ? progress.progress : 0) !== 100
                          ? ""
                          : "btn_disable"
                      ].join(" ")}
                      onClick={() => {
                        if (progress && progress.progress !== 100) {
                          sPopupMethods.openPopup("cancelRestore", {
                            body: {
                              CLIENT_NAME: decodeHandler(
                                props.clients[
                                  lState.slidingPopup.params.clientUUID
                                ].name
                              )
                            },
                            execute: () => {
                              props.initiateStopRestore(
                                lState.slidingPopup.params.clientUUID
                              );
                              sPopupMethods.closePopup();
                              lMethods.closeSlidingPopup();
                            }
                          });
                        }
                      }}
                    >
                      Stop Restore
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    clients: state.dashboard.clients.list,
    enums: state.common.enums
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      initiateStopRestore
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RestoreDetailedProgress);
